<template>

  <div>
    <!-- form novalidate class="md-layout" -->
    <md-card class="md-layout-item md-size-100">
      <md-card-header>
        <div class="md-title">Scarico</div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-vuelidated>
              <label for="deliveryNote">Delivery note</label>
              <md-input type="text" v-model="fields.deliveryNote" :disabled="!edit" />
              <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
            </md-vuelidated>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <div v-show="edit">
              <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.orderDate" md-immediately :disabled="!edit">
                <label for="orderDate">Order Date</label>
                <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
              </md-vuelidated>
            </div>
            <div v-show="!edit" class="input-display">
              <label for="orderDate">Order Date</label>
              <div class="input-value">{{fields.orderDate | formatDate}}</div>
            </div>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <!-- md-vuelidated -->
            <md-field>
              <label for="ordineDiCarico">Ordine di Carico</label>
              <md-input type="text" v-model="fields.ordineDiCarico" :disabled="!edit" />
            </md-field>
              <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
            <!-- /md-vuelidated -->
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <!-- md-vuelidated -->
            <md-field>
              <label for="elogate">ELOGATE</label>
              <md-input type="text" v-model="fields.elogate" :disabled="!edit" />
            </md-field>
              <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
            <!-- /md-vuelidated -->
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <!-- md-vuelidated -->
            <md-field>
              <label for="transportMean">Transport mean</label>
              <md-input type="text" v-model="fields.transportMean" :disabled="!edit" />
            </md-field>
              <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
            <!-- /md-vuelidated -->
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <!-- md-vuelidated -->
            <md-field>
              <label for="pos">Pos</label>
              <md-input type="text" v-model="fields.pos" :disabled="!edit" />
              <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
            <!-- /md-vuelidated -->
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <!-- md-vuelidated -->
            <md-field>
              <label for="cmr">CMR</label>
              <md-input type="text" v-model="fields.cmr" :disabled="!edit" />
              <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
            <!-- /md-vuelidated -->
            </md-field>
          </div>
        </div>
      </md-card-content>
      <md-card-actions v-show="step === 1">
        <md-button type="button"
                   class="md-primary md-raised"
                   :disabled="saving"
                   v-show="edit"
                   @click="selectDeliveryNote()">Avanti</md-button>
        <md-button type="button" class="md-primary" :disabled="saving" v-show="edit" @click="abort()">Annulla</md-button>
      </md-card-actions>
    </md-card>
    <md-dialog :md-active.sync="openDialog" class="fullScreen" v-on:md-clicked-outside="abort()">
    <md-dialog-content>
        <md-card class="md-layout-item md-size-100" v-show="step === 2">
        <md-card-header>
          <h3 class="md-title">Seleziona Nota di Carico</h3>
        </md-card-header>
        <md-card-content v-show="step === 2">
          <CaricoFiltri v-on:ricerca-ordini="findOrdiniDiCarico" button-label="Cerca"></CaricoFiltri>
          <md-table v-model="ordiniCarico" md-card @md-selected="onSelect">
            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select>
              <md-table-cell md-label="Delivery Note" md-sort-by="deliveryNote">{{ item.deliveryNote }}</md-table-cell>
              <md-table-cell md-label="Order Date" md-sort-by="orderDateIta">{{ item.orderDateIta }}</md-table-cell>
              <md-table-cell md-label="Delivery Date" md-sort-by="deliveryDateIta">{{ item.deliveryDateIta }}</md-table-cell>
              <md-table-cell md-label="Magazzino" md-sort-by="depotDesc">{{ item.depotDesc }}</md-table-cell>
              <md-table-cell md-label="Pos" md-sort-by="pos">{{ item.pos }}</md-table-cell>
              <md-table-cell md-label="Num. magazzino" md-sort-by="numeroMagazzino">{{ item.numeroMagazzino }}</md-table-cell>
              <md-table-cell md-label="SAP" md-sort-by="sap">{{ item.sap }}</md-table-cell>
              <md-table-cell md-label="ELOGATE" md-sort-by="elogate">{{ item.elogate }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <!-- <md-card-actions v-show="step === 2">
          <md-button type="button"
                     class="md-primary md-raised"
                     :disabled="saving || selected.length === 0"
                     v-show="edit"
                     @click="selectPallets()">Avanti</md-button>
          <md-button type="button" class="md-primary" :disabled="saving" v-show="edit" @click="abort()">Annulla</md-button> 
        </md-card-actions> -->
      </md-card>
  
      <md-card class="md-layout-item md-size-100" v-show="step >= 3">
        <md-card-header>
          <h3 class="md-title">Seleziona pallets</h3>
        </md-card-header>
        <md-card-content>
          <md-card class="dn md-size-100" v-for="dn in selected">
            <md-card-header class="md-layout dn-data">
              <div><strong>Nota di carico</strong> {{dn.deliveryNote}}</div>
              <div><strong>Magazzino</strong> {{dn.depotDesc}}</div>
            </md-card-header>
            <md-card-content>
              <div class="md-layout dn-row-data" v-for="sap in dn.details">
                <div class="md-layout-item md-size-100"><strong>SAP</strong> {{sap.materialNumber}} - {{sap.description}}</div>
                <div class="md-layout-item md-size-100 dn-row-pallet">
                  <strong>Pallets</strong>
                  <!-- md-button class="md-dense md-raised md-primary" @click="selectAllPallets(sap.ssccNumber)">Sel. tutti</md-button -->
                </div>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-20" v-for="pallet in sap.ssccNumber">
                    <md-checkbox v-model="pallet.selected">{{pallet.pallet}}</md-checkbox>
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </md-card-content>
    
    </md-dialog-content>
        <md-dialog-actions>
            <md-button type="button"
                class="md-primary md-raised"
                :disabled="saving || selected.length === 0"
                v-show="edit && step === 2"
                @click="selectPallets()">Seleziona Pallets</md-button>
            <md-button type="button"
                class="md-primary md-raised"
                :disabled="saving"
                v-show="edit && step === 3"
                @click="confirmAndSelect()">Conferma e seleziona altro</md-button>
            <md-button type="button"
                class="md-primary md-raised"
                :disabled="saving"
                v-show="edit && step === 3"
                @click="confirm()">Conferma e chiudi</md-button>        
            <md-button type="button" class="md-primary md-raised" @click="openDialog = false">Chiudi</md-button>
      </md-dialog-actions>
    </md-dialog>
    
   
    <md-card class="md-layout-item md-size-100" v-show="step >= 2">
    <md-card-header>
        <h3 class="md-title" style="flex: 1">Materiali selezionati</h3>
        <!-- md-button class="md-icon-button" @click="selectDeliveryNote()">
          <md-icon>add</md-icon>
        </md-button -->
    </md-card-header>
    <md-card-content>
        <md-table class="fullScreen">
        <md-table-row>
          <md-table-head>Mat. Number (SAP)</md-table-head>
          <md-table-head class="desc">Description</md-table-head>
          <md-table-head>Elogate</md-table-head>
          <md-table-head>Pcs/Unit</md-table-head>
          <md-table-head>Packaging amount</md-table-head>
          <md-table-head>Quantity</md-table-head>
          <md-table-head>Weight</md-table-head>
          <md-table-head class="action">&nbsp;</md-table-head>
        </md-table-row>
        <template v-for="row in sortedRows">
              <md-table-row :key="row.pos">
                <md-table-cell>{{row.materialNumber}}</md-table-cell>
                <md-table-cell  class="desc">{{row.description}}</md-table-cell>
                <md-table-cell>{{row.elogate}}</md-table-cell>
                <md-table-cell>{{row.pcsUnit.quantity}} / {{row.pcsUnit.unit}}</md-table-cell>
                <md-table-cell>{{row.packagingAmount.quantity}} / {{row.packagingAmount.unit}}</md-table-cell>
                <md-table-cell>{{row.quantity.quantity}} / {{row.quantity.unit}}</md-table-cell>
                <md-table-cell>{{row.weight.quantity}} / {{row.weight.unit}}</md-table-cell>
                <md-table-cell>
                  <!--md-button class="md-icon-button" @click="onEditRow(row)" :disabled="edit">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button class="md-icon-button" @click="onDeleteRow(row)" :disabled="edit">
                    <md-icon>delete_forever</md-icon>
                  </md-button>
                  <md-button class="md-icon-button" @click="print(row)" :disabled="edit">
                    <md-icon>print</md-icon>
                  </md-button -->
                </md-table-cell>
              </md-table-row>
              <md-table-row :key="row.pos" class="sscc">
                <md-table-cell colspan="8">
                  <div class="ssccToolbar">
                    <strong>SSCC No.:</strong>
                    <!-- md-button class="md-icon-button md-dense" @click="addSSCC(row.id)">
                      <md-icon>add</md-icon>
                    </md-button -->
                  </div>
                  <div class="ssccList">
                    <div class="ssccNumber" v-for="sscc in row.ssccNumber" :key="sscc.number" :class="{'broken' : sscc.rotto}">
                      <span>{{sscc.pallet}}</span>
                      <span>
                        <!--md-button class="md-icon-button md-dense" @click="brokenSSCC(sscc)">
                          <md-icon>broken_image</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-dense" @click="removeSSCC(sscc)">
                          <md-icon>delete</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-dense" @click="editSSCC(sscc)">
                          <md-icon>edit</md-icon>
                        </md-button-->
                      </span>
                    </div>
                  </div>
                </md-table-cell>
              </md-table-row>
            </template>
      </md-table>    
    </md-card-content>
    <md-dialog-actions>
        <md-button type="button"
            class="md-primary md-raised"
            :disabled="saving"
            v-show="edit"
            @click="save()">Salva</md-button>
        <md-button type="button" class="md-primary" :disabled="saving" v-show="edit" @click="abort()">Annulla</md-button>
    </md-dialog-actions>


        </div>
  </div>

</template>
<script>

import moment from 'moment'
import axios from 'axios'
import CaricoFiltri from './CaricoFiltri.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const instance = axios.create({
baseURL: window.appCfg.serviceURI
})

instance.interceptors.request.use(config => {
config.headers.common['Access-Control-Allow-Origin'] = '*'
return config
})

export default {
name: 'ScaricoNuovo',
mixins: [validationMixin],
components: {
  CaricoFiltri
},
data: function() {
  return {
    step: 1,
    selected: [],
    openDialog : false,
    fields: {
      orderDate: new Date(),
      deliveryNote: '',
      ordineDiCarico: '',
      elogate: '',
      details: [],
      transportMean: '',
      pos: '',
      cmr: '',
      depot: 0,
      numeroMagazzino: '',
      grossWeight: {
        quantity: '',
        unit: 'KG'
      },
      netWeight: {
        quantity: '',
        unit: 'KG'
      }
    },
    ordiniCarico: [],
    sending: false
  }
},
validations: {
  fields: {
    deliveryNote: {
      required
    },
    orderDate: {
      required
    },
  }
},
computed: {
    sortedRows: function() {
      return this.fields.details.sort((p1, p2) => {
        if (p1['pos'] < p2['pos']) return -1
        if (p1['pos'] > p2['pos']) return 1
        return 0
      })
    }
},
mounted() {
  this.edit = true
},
methods: {
  abort() {
    this.$fire({
      title: '',
      html: "Annullare tutte le modifiche?",
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Conferma'
    }).then(result => {
      if (result.value) {
        this.$router.push('/scarico')
      }
    })
  },
  selectDeliveryNote() {
    this.$v.$touch()
    if (this.$v.$invalid) {
      return
    }

    let loading = this.$loading.show()
    let params = { action: 'check', dn: this.fields.deliveryNote }
    this.$http
      .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
      .then(response => {
        loading.hide()
        if (!response.data.done) {
          this.$fire({
            html: response.data.message,
            type: 'error'
          }).then(r => {
            if (response.data.bu != '') this.$router.push(response.data.bu)
          })
        } else {
          this.step = 2
          this.selected = []
          this.ordiniCarico = []
          this.openDialog = true 
        }
      })
  },
  selectPallets() {
    if (this.selected.length == 0) return
    this.step = 3
  },
  onSelect(items) {
    this.selected = items
  },
  async findOrdiniDiCarico(filtri) {
    let loading = this.$loading.show()
    try {

      const params = { action: 'find', filters: filtri }
      const response = await this.$http.post('/data/scarico', params, {
        headers: { Authorization: 'Bearer ' + this.$cookie.get('token') }
      })
      if (!response.data.done) {
        /*this.pager =  {
            page : 1,
            max : 1
          }*/
        this.$fire({
          html: response.data.message,
          type: 'error'
        }).then(r => {
          if (response.data.bu != '') this.$router.push(response.data.bu)
        })
        return
      }
      this.ordiniCarico = response.data.data
      this.selected = [];
      /*this.pager = response.data.pager*/
      loading.hide()
    } catch (err) {
      loading.hide()
      if (err.response) {
        this.$fire({
          text: 'Server error: ' + err,
          type: 'error'
        })
      } else if (err.request) {
        this.$fire({
          text: 'Network error: ' + err,
          type: 'error'
        })
      } else {
        this.$fire({
          text: 'System error: ' + err,
          type: 'error'
        })
      }
    }
  },
  findSap(list, id) {
        return list.find( el => el.originalDeliveryNoteRow === id)
  },
  findPallet(list, pallet) {
      return list.find( el => el.pallet === pallet)
  },
  confirmAndSelect(){
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.getSelectedPallets()
      
      // Torno allo step prima
      this.selectDeliveryNote()
  },
  getSelectedPallets(){
      for (var k in this.selected){
          for (var y in this.selected[k].details){
            for (var z in this.selected[k].details[y].ssccNumber){
              if (this.selected[k].details[y].ssccNumber[z].selected) {
                let pallet = JSON.parse(JSON.stringify(this.selected[k].details[y].ssccNumber[z]));
                let sap = this.findSap(this.fields.details, this.selected[k].details[y].id);
                if (!sap){
                    sap = JSON.parse(JSON.stringify(this.selected[k].details[y]))
                    sap.originalDeliveryNoteRow = sap.id
                    sap.id = 0
                    sap.ssccNumber = []
                    this.fields.details.push(sap)
                } else {
                    // gia' selezionato??
                    if (this.findPallet(sap.ssccNumber, pallet.pallet)) continue
                }
                pallet.idPalletInCarico = pallet.id
                pallet.id = 0
                sap.ssccNumber.push( pallet )
              }
            }
          }
        }  
  },
  confirm() {
    this.$v.$touch()
    if (this.$v.$invalid) {
      return
    }
    this.openDialog = false
    this.getSelectedPallets()
  },
save(){
  this.$v.$touch()
  if (this.$v.$invalid) {
    return
  }
      
    // Formatto la data
    this.fields.orderDate = moment(String(this.fields.orderDate)).format('YYYY-MM-DD')

    let params = {
      action: 'save',
      what: 'full',
      data: this.fields
    }

    this.sending = true
    let loading = this.$loading.show()
    this.$http
      .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
      .then(response => {
        this.sending = false
        loading.hide()
        if (response.data.done) {
          this.$fire({
            html: 'Ordine di scarico salvato',
            type: 'success',
            showCloseButton: true,
            showCancelButton: false
          }).then(r => {
            this.$router.push('/scarico')
          })
        } else {
          this.$fire({
            html: response.data.message,
            type: 'error'
          }).then(r => {
            if (response.data.bu != '') this.$router.push(response.data.bu)
          })
        }
      })
      .catch(function(error) {
        this.$fire({
          html: 'Errore di sistema: ' + error.response,
          type: 'error'
        })
      })
    }
  }
}
</script>
<style lang="css" scoped>

  .step {
    text-align: start;
    display: flex;
    background-color: #f5f5f5;
  }
  .step .md-icon {
    margin-right: 10px;
    flex-grow: 0;
    flex-shrink: 0;
  }
  .step h3.md-title {
    flex-grow: 1;
    font-size: 20px;
    margin-left: 0;
  }
  .md-icon.success {
    color: #a5dc86 !important;
  }
  .dn {margin: 15px 0;}
  .dn-data {
    font-size: 16px;
  background-color: #f9f9f9;
  }
  .dn-data > div {margin-right:20px;}
  .dn-row-data {
    text-align: left;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 15px;
  }
  .dn-row-data:last-child {
    border-bottom: 0;
    margin-bottom: initial;
  }
  .dn-row-pallet {
    display: flex;
    align-items: center;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScaricoNuovo.vue